import { Alert } from 'react-bootstrap';
import { EquipmentItem } from '@/backend/models/equipmentItem';
import { I18n } from '@/i18n/I18n';
import { useEquipmentConnection } from '@/frontend/hooks/useEquipmentConnection';
import { InstrumentSelect } from './InstrumentSelect';

/**
 * Assigning an instrument to an equipment item, and starting the connection.
 *
 * The card form, shown on an equipment operation. The equipment table shows the
 * same controls as a cell; both are driven by `useEquipmentConnection`.
 *
 * Both sides of this live in veriform-desktop: the instruments are configured
 * on that machine and the connection is held by the workflow engine. In an
 * ordinary browser there is nothing to ask, so this says so rather than
 * offering a control that cannot work.
 */

export function EquipmentConnection(props: { equipment: EquipmentItem }) {
  const { equipment } = props;
  const connection = useEquipmentConnection(equipment);

  if (!connection.framed) {
    return <Alert variant="warning" className="mb-3">{I18n.get('instrumentConnectionNotSupported')}</Alert>;
  }

  return (
    <div className="mb-3">
      <label className="form-label mb-1" htmlFor={`instrument-${equipment.id}`}>
        <strong>{I18n.get('instrument')}</strong>
      </label>
      <InstrumentSelect equipment={equipment} connection={connection} />
    </div>
  );
}
